<template>
  <section class="video-container">
    <v-col cols="12">
      <v-card class="pa-sm-3 d-flex justify-center" :elevation="0">
        <v-col cols="12" md="8">
          <v-responsive :aspect-ratio="16 / 9">
            <div v-html="videoEmbed" class="responsive-video"></div>
          </v-responsive>
        </v-col>
      </v-card>
    </v-col>
  </section>
</template>
<script>
export default {
  name: "VideoContainer",
  data() {
    return {
      videoEmbed:
        '<iframe width="560" height="315" src="https://www.youtube.com/embed/LbBT75nHqZk" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',
    };
  },
};
</script>
<style lang="scss">
.responsive-video {
  position: relative;
  padding-bottom: 56.25%;
  padding-top: 30px;
  height: 0;
  overflow: hidden;

  iframe,
  object,
  embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>
